import prepareComponent from "@bluframe/grapple/prepareComponent";
import useActionsCheckbox from "hooks/actions/useActionsCheckbox";
import useListButton from "hooks/actions/useListButton";
import Actions from "./Actions";
const usePrepareComponent = ({ serviceName }) => {
    const allAroundGatherProps = useActionsCheckbox({
        inputId: `${serviceName}-isAllAroundGather`,
        isNeedsDisplayList: false,
        label: "All Around Gather",
        serviceName,
        serviceType: "reviews",
        setValueName: "setIsAllAroundGather",
        valueName: "isAllAroundGather"
    });
    const onlyNewProps = useActionsCheckbox({
        inputId: `${serviceName}-isOnlyNew`,
        label: "Only New",
        serviceName,
        serviceType: "reviews",
        setValueName: "setIsOnlyNew",
        valueName: "isOnlyNew"
    });
    const listButtonProps = useListButton({
        serviceName,
        serviceType: "reviews"
    });
    return {
        allAroundGatherProps,
        listButtonProps,
        onlyNewProps,
        serviceName
    };
};
export default prepareComponent(usePrepareComponent)(Actions);
